/**
 * Rental reservation action values
 */
export enum RentalReservationActionEnum {
	/**
	 * Set rental reservation status to pending
	 */
	PENDING = 'make_pending',
	/**
	 * Set rental reservation status to accepted
	 */
	ACCEPT = 'accept',
	/**
	 * Set rental reservation status to rejected
	 */
	REJECT = 'reject',
	/**
	 * Send payment link to customer via email
	 */
	SEND_PAYMENT_LINK = 'send_payment_link',
}
